module.exports = __webpack_public_path__ + "static/media/yu_hsiang_tseng.8e675f0e.jpg";